import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { GOALS } from '../../data/staticContent';

const Goals = () => {
  const { t } = useLanguage();

  return (
    <section className="section-pad">
      <div className="container">
        <div className="row g-5 align-items-start">

          {/* ── Sticky sidebar ── */}
          <div className="col-lg-4">
            <div className="sticky-sidebar">
              <h2 className="section-title">{t('goals.title')}</h2>
              <div className="divider-brand"></div>
              <p className="body-text">{t('goals.subtitle')}</p>
              <div className="sidebar-quote-box mt-3">
                <i className="bi bi-stars" style={{fontSize:'2.5rem',opacity:0.15,display:'block',marginBottom:'0.5rem'}}></i>
                <div className="sidebar-quote-text">{t('goals.sidebarQuote')}</div>
                <div className="sidebar-quote-attr">{t('goals.sidebarAttr')}</div>
              </div>
            </div>
          </div>

          {/* ── Goal items ── */}
          <div className="col-lg-8">
            {GOALS.map((key, i) => (
              <div
                key={key}
                className={`goal-item mb-3 anim-fade-up anim-delay-${i + 1}`}
              >
                <div className="goal-number">{String(i + 1).padStart(2, '0')}</div>
                <div>
                  <div className="goal-title">{t(`goals.${key}Title`)}</div>
                  <p className="goal-desc mb-0">{t(`goals.${key}Desc`)}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Goals;
